module.exports = __webpack_public_path__ + "img/title-bg.4117ba42.png";